import {ServerStatus} from '../model/Server/IServer';

export type ServerBackgroundKind = 'ok' | 'problem' | 'paused' | 'en' | null;

export const getServerBackgroundKind = (
    status: ServerStatus,
    isEnglishBrand: boolean,
): ServerBackgroundKind => {
    if (isEnglishBrand) return 'en';

    if (status === 'online') return 'ok';
    if (status === 'offline' || status === 'suspended') return 'problem';
    if (status === 'paused') return 'paused';

    return null;
};

export const getServerDateFormat = (isEnglishBrand: boolean): string => (
    isEnglishBrand ? 'YYYY-MM-DD HH:mm' : 'DD.MM.YYYY HH:mm'
);

export type ServerAgentScriptVariant = 'install' | 'setToken';

interface IAgentCommandParams {
    variant: ServerAgentScriptVariant,
    token: string,
    repoOwner: string | undefined,
    baseHost: string | undefined,
}

export const buildServerAgentCommand = ({variant, token, repoOwner, baseHost}: IAgentCommandParams): string => {
    const scriptName = variant === 'setToken' ? 'set-token.sh' : 'install.sh';
    const scriptArgs = variant === 'setToken'
        ? token
        : `--endpoint ${baseHost}/api/agent/v1/metrics ${token}`;

    // eslint-disable-next-line max-len
    return `curl -fsSL https://github.com/${repoOwner}/metrics-agent/releases/latest/download/${scriptName} | sudo sh -s -- ${scriptArgs}`;
};

export const isServerAgentConnected = (
    status: ServerStatus | undefined,
    lastSeenAt: string | null | undefined,
    openedAt: number,
): boolean => {
    const lastSeen = lastSeenAt ? new Date(lastSeenAt).getTime() : null;

    return status === 'online' && lastSeen !== null && lastSeen >= openedAt;
};
